module.exports = __webpack_public_path__ + "img/cover.8096f6a3.jpg";